import { derivarPeriodo, parseFecha } from "../parseFecha";

// Parser puro de la factura PDF de Google Workspace -> shape transversal
//   { folio, fecha, periodo, concepto, monto, moneda, unidades }
// Anclas verificadas sobre el texto real de pdfjs. Obligatorios (throw): folio, monto.
// OJO layout "detached": folio/monto/fecha vienen en bloques sueltos (se anclan sobre el texto
// crudo, ya daban verde). concepto/unidades salen de una linea de la PAGINA 2 -> sobre `t` normalizado.
export const parsearGoogleWorkspaceDesdeTexto = (texto) => {
  // pdfjs mete espacios multiples -> `t` normalizado para las anclas en linea (concepto/unidades).
  const t = texto.replace(/\s+/g, " ");

  // folio: tras "Numero de factura:" -> "5617350045" (tolera acento en Numero). Obligatorio. SIN CAMBIOS.
  const mFolio = texto.match(/N[uú]mero de factura:?\s*(\d+)/);
  if (!mFolio) throw new Error("No se reconoce el formato de factura Google Workspace (falta Numero de factura)");
  const folio = mFolio[1];

  // monto: tras "Total en USD" -> "91,20   US$" (coma decimal, espacio antes de US$). NO agarrar "0,00".
  // Obligatorio. Coma decimal + punto de miles -> normalizar a punto. SIN CAMBIOS.
  const mMonto = texto.match(/Total en USD\s+([\d.]*\d,\d{2})\s*US\$/);
  if (!mMonto) throw new Error("No se pudo leer el Total en USD de la factura Google Workspace");
  const monto = Number(mMonto[1].replace(/\./g, "").replace(",", "."));

  // fecha: fecha del bloque Detalles -> "30 jun 2026". Best-effort. Se prioriza una fecha etiquetada
  // como "Fecha"; si no, se cae al fin del "Resumen" (dia de emision de Google). SIN CAMBIOS.
  const mFecha = texto.match(/fecha\D{0,20}(\d{1,2}\s+[.a-z]{3,}\.?\s+\d{4})/i);
  const fechaDetalle = mFecha ? parseFecha(mFecha[1].replace(/\./g, "")) : null;
  const mPeriodoFin = texto.match(
    /resumen de\s+\d{1,2}\s+[.a-z]{3,}\.?\s+\d{4}\s*[–-]\s*(\d{1,2}\s+[.a-z]{3,}\.?\s+\d{4})/i
  );
  const fechaFinPeriodo = mPeriodoFin ? parseFecha(mPeriodoFin[1].replace(/\./g, "")) : null;
  const fecha = fechaDetalle || fechaFinPeriodo;

  // concepto: linea de la pag 2 "Importe (US$) Google Workspace Business Standard Utilización ...".
  // Best-effort.
  const mConcepto = t.match(/Importe \(US\$\)\s+(.+?)\s+Utilización/);
  const concepto = mConcepto ? mConcepto[1].trim() : "";

  // unidades: la Cantidad de la linea ACTIVA "...Business Standard Utilización 1 jun - 30 jun 5 84,00"
  // -> 5 (NO la linea "Business Standard: Usuario archivado ... 2"). Best-effort.
  const mUnidades = t.match(/Business Standard\s+Utilización\s+\d{1,2} \w+ - \d{1,2} \w+\s+(\d+)/);
  const unidades = mUnidades ? Number(mUnidades[1]) : null;

  return { folio, fecha, periodo: derivarPeriodo(fecha), concepto, monto, moneda: "USD", unidades };
};
